export default class OpportunitySourceDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { createdDate: json.createdDate && new Date(json.createdDate), modifiedDate: json.modifiedDate && new Date(json.modifiedDate) });
    }
}
